import userAPI from './userAPI';

export default {
  single: userAPI,
};
